import { ApplicationState } from 'ducks/application-state';

export const selectSignUpLoading = (state: ApplicationState) => state.app.loading.signUp;
export const selectSignInLoading = (state: ApplicationState) => state.app.loading.signIn;
export const selectPasswordRecovery = (state: ApplicationState) => state.app.passwordRecovery;
export const selectIsRegistrationFinish = (state: ApplicationState) => state.app.isRegistrationFinish;
